import { getI18n } from "@/services/localisation";

export function useTranslate() {
    const i18n = getI18n()
    return i18n.global.t
}